import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './modules/auth/guards/auth.guard';
import { IsStoreGuard } from './modules/auth/guards/is-store.guard';
import { LayoutComponent } from './modules/layout/components/layout/layout.component';
import { SiteInMaintenanceGuard } from './modules/auth/guards/site-in-maintenance.guard';
import { ReverseSiteInMaintenanceGuard } from './modules/auth/guards/reverse-site-in-maintenance.guard';

const routes: Routes = [
	{
		path: '',
		component: LayoutComponent,
		children: [
			{
				path: 'auth',
				loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
			},
            {
				path: "nuestros-pilares",
				loadChildren: () => import('./modules/our-values/our-values.module').then(m => m.OurValuesModule),
			},
            {
				path: "preguntas-frecuentes",
				loadChildren: () => import('./modules/faq/faq.module').then(m => m.FaqModule),
			},
			{
				path: "quienes-somos",
				loadChildren: () => import('./modules/about-us/about-us.module').then(m => m.AboutUsModule),
			},
			{
				path: "politicas-de-privacidad",
				loadChildren: () => import('./modules/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
			},
			{
				path: "terminos",
				loadChildren: () => import('./modules/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule),
			},
			{
				path: "vender",
				loadChildren: () => import('./modules/product-form/product-form.module').then(m => m.ProductFormModule),
				canActivate: [IsStoreGuard],
				data: {
					ifNotStoreRedirectTo: "/mi-perfil?s=true",
				}
			},
			{
				path: "buscar",
				loadChildren: () => import('./modules/product-search/product-search.module').then(m => m.ProductSearchModule),
			},
			{
				path: "comprar",
				loadChildren: () => import('./modules/product/product.module').then(m => m.ProductModule),
			},
			{
				path: "mi-perfil",
				loadChildren: () => import('./modules/user-profile/user-profile.module').then(m => m.UserProfileModule),
				canActivate: [AuthGuard]
			},
			{
				path: "mis-compras",
				loadChildren: () => import('./modules/my-purchases/my-purchases.module').then(m => m.MyPurchasesModule),
				canActivate: [AuthGuard]
			},
			{
				path: "mis-ventas",
				loadChildren: () => import('./modules/my-sales/my-sales.module').then(m => m.MySalesModule),
				canActivate: [IsStoreGuard],
				data: {
					ifNotStoreRedirectTo: "/pagina_no_encontrada",
				}
			},
			{
				path: "mercado-pago",
				loadChildren: () => import('./modules/mercado-pago/mercado-pago.module').then(m => m.MercadoPagoModule),
				canActivate: [IsStoreGuard],
				data: {
					ifNotStoreRedirectTo: "/pagina_no_encontrada",
				}
			},
			{
				path: "carrito",
				loadChildren: () => import('./modules/cart/cart.module').then(m => m.CartModule),
				canActivate: [AuthGuard]
			},
			{
				path: "ecotrends",
				loadChildren: () => import('./modules/ecotrends/ecotrends.module').then(m => m.EcotrendsModule),
			},
			{
				path: "tienda",
				loadChildren: () => import('./modules/store/store.module').then(m => m.StoreModule),
			},
			{
				path: "notificaciones",
				loadChildren: () => import('./modules/notifications/notifications.module').then(m => m.NotificationsModule),
				canActivate: [AuthGuard]
			},
			{
				path: "ayuda",
				loadChildren: () => import('./modules/help/help.module').then(m => m.HelpModule),
			},
			{
				path: "pagina-no-encontrada",
				loadChildren: () => import('./modules/error-not-found/error-not-found.module').then(m => m.ErrorNotFoundModule),
				data: { preload: true }
			},
			{
				path: "error",
				loadChildren: () => import('./modules/internal-error/internal-error.module').then(m => m.InternalErrorModule),
			},
			{
				path: '',
				loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
				data: { preload: true }
			},
		],
		canActivate: [SiteInMaintenanceGuard],
	},
	{
		path: "mantenimiento",
		loadChildren: () => import('./modules/maintenance/maintenance.module').then(m => m.MaintenanceModule),
		canActivate: [ReverseSiteInMaintenanceGuard],
	},
	{ path: '**', redirectTo: "pagina-no-encontrada", pathMatch: 'full' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {
		scrollPositionRestoration: "top",
		anchorScrolling: 'enabled',
		onSameUrlNavigation: "reload"		// Nunca anduvo. Hasta gpt dice que es una mierda
	})],
	exports: [RouterModule]
})
export class AppRoutingModule { }